(function () {
  var STORAGE_KEY = 'kevilagu:wishlist';

  function readHandles() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeHandles(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      // Storage unavailable (private browsing, quota, etc.) - fail silently.
    }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: handles } }));
  }

  function has(handle) {
    return readHandles().indexOf(handle) !== -1;
  }

  function add(handle) {
    var handles = readHandles();
    if (handles.indexOf(handle) === -1) {
      handles.push(handle);
      writeHandles(handles);
    }
  }

  function remove(handle) {
    writeHandles(
      readHandles().filter(function (item) {
        return item !== handle;
      })
    );
  }

  function toggle(handle) {
    if (has(handle)) {
      remove(handle);
      return false;
    }
    add(handle);
    return true;
  }

  window.Wishlist = {
    getAll: readHandles,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
  };

  function syncToggleButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-wishlist-handle');
      var active = has(handle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = button.getAttribute('data-wishlist-handle');
    if (handle) toggle(handle);
  });

  document.addEventListener('wishlist:updated', syncToggleButtons);
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) syncToggleButtons();
  });
  syncToggleButtons();

  // --- Wishlist page renderer ------------------------------------------------

  var grid = document.querySelector('[data-wishlist-grid]');
  if (!grid) return;

  var emptyState = document.querySelector('[data-wishlist-empty]');
  var loadingState = document.querySelector('[data-wishlist-loading]');
  var moneyFormat = window.shopMoneyFormat || '${{amount}}';

  var REMOVE_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" d="M9 7.94 13.42 3.5l1.06 1.06L10.06 9l4.42 4.44-1.06 1.06L9 10.06l-4.44 4.44-1.06-1.06L7.94 9 3.5 4.56l1.06-1.06z"/></svg>';

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var precision = moneyFormat.indexOf('amount_no_decimals') !== -1 ? 0 : 2;
    var amount = (Number(cents) / 100).toFixed(precision);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    var value = parts[1] ? dollars + '.' + parts[1] : dollars;
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function resizeImage(url, size) {
    if (!url) return url;
    var absolute = url.indexOf('//') === 0 ? 'https:' + url : url;
    return absolute.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '_' + size + 'x.$1$2');
  }

  function getImageUrl(product) {
    if (product.media && product.media.length && product.media[0].preview_image) {
      return product.media[0].preview_image.src;
    }
    return product.featured_image || (product.images && product.images[0]) || '';
  }

  function buildCard(product, handle) {
    var card = document.createElement('div');
    card.className = 'wishlist-card';

    var image = getImageUrl(product);
    var price = formatMoney(product.price);
    var compareAt =
      product.compare_at_price && product.compare_at_price > product.price
        ? '<s>' + formatMoney(product.compare_at_price) + '</s>'
        : '';

    card.innerHTML =
      '<a href="' +
      product.url +
      '" class="wishlist-card__media">' +
      (image
        ? '<img src="' +
          resizeImage(image, 400) +
          '" alt="' +
          escapeHtml(product.title) +
          '" loading="lazy" width="400" height="400" onerror="this.closest(\'.wishlist-card__media\').classList.add(\'wishlist-card__media--broken\');this.remove();">'
        : '') +
      '</a>' +
      '<button type="button" class="wishlist-card__remove" data-wishlist-remove data-wishlist-handle="' +
      handle +
      '" aria-label="Remove from wishlist">' +
      REMOVE_ICON +
      '</button>' +
      '<a href="' +
      product.url +
      '" class="wishlist-card__title">' +
      escapeHtml(product.title) +
      '</a>' +
      '<div class="wishlist-card__price">' +
      price +
      compareAt +
      '</div>';

    return card;
  }

  function updateEmptyState() {
    var isEmpty = grid.children.length === 0;
    if (emptyState) emptyState.classList.toggle('is-visible', isEmpty);
  }

  function renderGrid() {
    var handles = readHandles();

    if (loadingState) loadingState.hidden = handles.length === 0;
    if (handles.length === 0) {
      updateEmptyState();
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (response) {
            if (!response.ok) throw new Error('Not found');
            return response.json();
          })
          .then(function (product) {
            return { handle: handle, product: product };
          })
          .catch(function () {
            remove(handle);
            return null;
          });
      })
    ).then(function (results) {
      if (loadingState) loadingState.hidden = true;
      results
        .filter(Boolean)
        .forEach(function (result) {
          grid.appendChild(buildCard(result.product, result.handle));
        });
      updateEmptyState();
    });
  }

  grid.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-remove]');
    if (!button) return;
    var handle = button.getAttribute('data-wishlist-handle');
    remove(handle);
    button.closest('.wishlist-card').remove();
    updateEmptyState();
  });

  renderGrid();
})();
